import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AccountRoleType } from '../../Models/Domains/Customers/AccountRoleType';

declare var IS_RUNNING_IN_APP_POOL;

export class AvailableAccountRoleClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(investorTypes: Array<number>, customerId: number, hierarchyIds: Array<string>): Promise<Array<AccountRoleType>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/AvailableAccountRole/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { investorTypes: investorTypes, customerId: customerId, hierarchyIds: hierarchyIds }

    return AjaxWrapper.get<Array<AccountRoleType>, any>(url, data);
  }
}

